import { render } from "./ReportProvider.vue?vue&type=template&id=3fc5354a&scoped=true"
import script from "./ReportProvider.vue?vue&type=script&lang=js"
export * from "./ReportProvider.vue?vue&type=script&lang=js"

import "./ReportProvider.vue?vue&type=style&index=0&id=3fc5354a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc5354a"]])

export default __exports__